import { AbstractControl } from '@angular/forms';

export default function maxAmount(amount: number) {
  return (control: AbstractControl) => {
    if (control && control.value) {
      const value = parseFloat(control.value.replace(/([^0-9\.])/g, ''));
      if (isNaN(value)) {
        return null;
      }
      if (value > amount) {
        return { maxAmount: true };
      }
    }
    return null;
  };
}
